import styled from 'styled-components'

export const WrapperContent = styled.div`
  min-height: calc(100vh - 225px);

  .styledCenterLoading__StyledCenterLoading-hwbsbr-0{
    min-height: calc(100vh - 225px);
  }
`

export const Actions = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: flex-end;
  padding: 8px 0px 0px 0px;

  .div-filters {
    width: auto;
    margin-right: 20px;

    .btn-tipo-visualizacao {
      padding-right: 0;
    }
  }

  .btnAcept {
    width: fit-content;
    margin-right: 8px;
  }

  .btn-import-export-order {
    width: 45px;
  }

  .action-buttons {
    div {
      margin: 3px;
    }
  }
`
